<template>
  <div class="flex flex-col gap-6">
    <slot></slot>
  </div>
</template>
